import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import 'rc-slider/assets/index.css';
// import 'rc-tooltip/assets/bootstrap.css';
import Slider, { Handle } from 'rc-slider';
import Tooltip from 'rc-tooltip';
import ArrowUpIcon from 'assets/icons/enter.svg';
import './ChatSlideInput.scss';
import classNames from 'classnames';
import SliderIcon from '../../../assets/icons/sliderHandle@2x.png';

const ChatSlideInput = ({
  min, max, defaultValue, intl, minlabel, maxlabel, onSubmit, unit, rtl,
}) => {
  const [value, setValue] = useState(defaultValue);

  const handle = (props) => {
    const {
      dragging, index, ...restProps
    } = props;
    const newVal = `${value} ${value <= 1 ? intl.formatMessage({ id: unit }) : intl.formatMessage({ id: `${unit}s` })}`;
    return (
      <Tooltip prefixCls="rc-slider-tooltip" overlay={newVal} placement="top" visible={dragging}>
        <Handle value={value} {...restProps} />
      </Tooltip>
    );
  };

  const marks = {
    [min]:
        {
          style:
          {
            color: '#ffffff',
            marginLeft: 0,
            width: 'auto',
          },
          label: `${min} ${minlabel ? intl.formatMessage({ id: minlabel }) : ''}`,
        },
    [max]:
        {
          style:
          {
            position: 'absolute',
            color: '#ffffff',
            right: 0,
            width: 'auto',
            textAlign: 'right',
          },
          label: `${max} ${maxlabel ? intl.formatMessage({ id: maxlabel }) : ''}`,
        },
  };

  const onSliderChange = (val) => {
    setValue(val);
  };

  const onButtonClick = () => {
    onSubmit(value.toString(), 'age');
  };

  const onTestInputChange = (e) => {
    setValue(e.target.value);
  };

  const classes = classNames({
    'nw-input-slider': true,
    'nw-input-slider--rtl': rtl,
  });

  return (
    <div className={classes}>
      <input value={value} onChange={onTestInputChange} className="test-dummy" />
      <Slider
        trackStyle={{ backgroundColor: '#e48196', height: 8 }}
        railStyle={{ backgroundColor: '#004273', height: 8 }}
        handleStyle={{
          backgroundImage: `url(${SliderIcon})`, backgroundSize: '100%', height: 30, width: 30, marginTop: -12, border: '2px solid #fff',
        }}
        max={max}
        min={min}
        value={value}
        defaultValue={defaultValue}
        marks={marks}
        dotStyle={{ display: 'none' }}
        onChange={onSliderChange}
        handle={handle}
      />
      <button type="button" className="nw-button nw-button--icon nw-button--submit" onClick={onButtonClick}>
        <img src={ArrowUpIcon} alt="Submit" />
      </button>
    </div>
  );
};

ChatSlideInput.propTypes = {
  /** Minimum slider number */
  min: PropTypes.number,
  /** Maximum slider number */
  max: PropTypes.number,
  /** Slider default value */
  defaultValue: PropTypes.number,
  /** Submit value function */
  onSubmit: PropTypes.func,
  /** Minimum Label */
  minlabel: PropTypes.string,
  /** Maximum Label */
  maxlabel: PropTypes.string,
  /** Unit */
  unit: PropTypes.string,
  /** isRTL */
  rtl: PropTypes.bool,
};

ChatSlideInput.defaultProps = {
  min: 1,
  max: 100,
  defaultValue: 5,
  onSubmit: () => {},
  minlabel: '',
  maxlabel: '',
  unit: 'year',
  rtl: false,
};

export default injectIntl(ChatSlideInput);
